<template>
	<div class="bigScreen" v-cloak>
		<div class="visTopBg">
			<div class="visbg">区域影像中心全方位数据总览</div>
			<div class="visCount mart25">
				历史总质控报告数
				<numberGrow class="visFigure" v-if="destroy.flag" :value="reportCountList.QCedCount"></numberGrow>
			</div>
			<div class="visTime">
				<div class="sliderScreeningCC">
					<span class="text fz16 marr8">选择时间</span>
					<el-date-picker
						class="sliderDataCls visDataCls visDataClsMonth"
						v-model="setDateArr.data"
						type="monthrange"
						@change="datePicker"
						unlink-panels
						:picker-options="pickerOptions"
						range-separator="~"
						value-format="yyyy/MM"
						format="yyyy-MM"
						start-placeholder="开始时间"
						end-placeholder="结束时间"
					></el-date-picker>
				</div>
			</div>
		</div>
		<div class="visContent">
			<el-row>
				<el-col :span="6">
					<visbg><vis-number-grow v-loading="countLoading"></vis-number-grow></visbg>
					<visbg><vis-pie-list v-loading="pieLoading"></vis-pie-list></visbg>
					<visbg>
						<vis-table 
						v-loading="tableLoading" 
						:title="'全国医生'" 
						:icon="'iconvisDoctor'" 
						:className="'colwhite'" 
						:type="'2'" 
						:dataList="doctorsAvgScore.Doctors">
							<el-button size="mini" round class="tableBtn" @click="doctorMore(2)">更多</el-button>
						</vis-table>
					</visbg>
					<visbg>
						<vis-table
							v-loading="tableLoading"
							:title="'全国技师'"
							:icon="'iconvisTechnician'"
							:className="'colwhite'"
							:type="'3'"
							:dataList="technicianAvgScore.Doctors"
						>
							<el-button size="mini" round class="tableBtn" @click="doctorMore(3)">更多</el-button>
						</vis-table>
					</visbg>
				</el-col>
				<el-col :span="12"><vis-map-china v-loading="mapLoading"></vis-map-china></el-col>
				<el-col :span="6" class="visContentRight">
					<visbg><vis-line-charts v-loading="lineLoading"></vis-line-charts></visbg>
					<visbg>
						<vis-portrait-line
							v-loading="portraitLoading"
							class="barBoxHeight"
							:icon="'iconvisReport'"
							:title="'月度报告数量'"
							:unit="'份'"
							:status="'all'"
							tooltip="报告数"
							:unqualifiedStatus="'false'"
							:chartsType="'bar'"
							:colorList="['#22B583', '#6bf4c6', '#2B5F53']"
							@moveQCedReportMonthly="moveQCedReportMonthly"
							:name="'moveQCedReportMonthly'"
							:reportList="qcedReportMonthlyList"
							:type="'count'"
						></vis-portrait-line>
					</visbg>
					<visbg>
						<vis-double-line
							v-loading="doublelineLoading"
							:icon="'iconvisReport'"
							:title="'月度不合格报告'"
							:unit="'份'"
							:chartsType="'line'"
							:status="'all'"
							:unqualifiedStatus="'true'"
							:breadcrumbType="'regionFfalse'"
							:colorList="['#2181FF', '#6BB1FF', '#22B583', '#6bf4c6', '#2B5F53']"
							@moveunqualifiedMonthly="moveunqualifiedMonthly"
							:name="'moveunqualifiedMonthly'"
							:reportList="unqualifiedMonthlyList"
						></vis-double-line>
					</visbg>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
// import axios from "axios";
import numberGrow from '../../components/tool/numberGrow';
import visbg from '@/components/visualization/visbg';
import visNumberGrow from '@/components/visualization/visNumberGrow';
import visPieList from '@/components/visualization/visPieList';
import visTable from '@/components/visualization/visTable';
import visLineCharts from '@/components/visualization/visLineCharts';
import visPortraitLine from '@/components/visualization/visPortraitLine';
import visDoubleLine from '@/components/visualization/visDoubleLine';
import visMapChina from '@/components/visualization/visMapChina';
// import { mapState, mapActions, mapMutations} from 'vuex'
export default {
	components: {
		numberGrow,
		visbg,
		visNumberGrow,
		visPieList,
		visTable,
		visLineCharts,
		visPortraitLine,
		visDoubleLine,
		visMapChina
	},
	data() {
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [new Date(), new Date()]);
						}
					},
					{
						text: '今年至今',
						onClick(picker) {
							const end = new Date();
							const start = new Date(new Date().getFullYear(), 0);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近六个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 6);
							picker.$emit('pick', [start, end]);
						}
					}
				],
				onPick: obj => {
					this.pickerMinDate = new Date(obj.minDate).getTime();
				},
				disabledDate: time => {
					if (this.pickerMinDate) {
						const day1 = 365 * 24 * 3600 * 1000;
						let maxTime = this.pickerMinDate + day1;
						let minTime = this.pickerMinDate - day1;
						return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 1 * 24 * 3600 * 1000;
					} else {
						return time.getTime() > Date.now() - 1 * 24 * 3600 * 1000;
					}
				}
			},
			parameter: {},
			countLoading: false,
			pieLoading: false,
			tableLoading: false,
			mapLoading: false,
			lineLoading: false,
			portraitLoading: false,
			doublelineLoading: false
		};
	},
	computed: {
		...Vuex.mapState('breadcrumb', ['bg', 'loading']),
		...Vuex.mapState('supervisor', ['destroy']),
		...Vuex.mapState('visualization', [
			'setDateArr',
			'doctorsAvgScore',
			'technicianAvgScore',
			'reportCountList',
			'qcedReportMonthlyList',
			'unqualifiedMonthlyList',
			'getAvgScoreParameter',
			'getCountParameter',
			'visbreadcrumbList'
		])
	},
	watch: {
		setDateArr(old, news) {
			this.setDateArr.data = news.data;
		}
	},
	activated() {
		let _this = this;
		this.getCountParameter.hospitalGuid = '';
		this.callFunction(this.setDateArr.data);
		this.$nextTick(() => {
			_this.bg.flag = true;
		});
	},
	methods: {
		...Vuex.mapMutations('breadcrumb', ['setLoading', 'setTootipType']),
		...Vuex.mapMutations('visualization', ['setDate', 'setvisBreadcrumbList']),
		...Vuex.mapActions('visualization', [
			'GetCount',
			'GetRegions',
			'GetSummary',
			'GetDoctorsTop5AvgScore',
			'GetHospAvgScore',
			'GetQCedReportMonthly',
			'GetUnqualifiedReportMonthly',
			'GetRegionAVGScore'
		]),
		setloadingList(flag) {
			this.countLoading = flag;
			this.pieLoading = flag;
			this.tableLoading = flag;
			this.mapLoading = flag;
			this.lineLoading = flag;
			this.portraitLoading = flag;
			this.doublelineLoading = flag;
		},
		setPar(dateVal, type) {
			this.getAvgScoreParameter.type = type;
			this.getAvgScoreParameter.pageIndex = 1;
			this.getAvgScoreParameter.pageCount = 5;
			this.getAvgScoreParameter.regionId = '';
			this.getAvgScoreParameter.startdt = dateVal[0];
			this.getAvgScoreParameter.enddt = dateVal[1];
			this.getAvgScoreParameter.hospitalGuid = '';

			this.getCountParameter.type = 2;
			this.getCountParameter.doctorName = '';
			this.getCountParameter.regionId = localStorage.getItem('user').regionIds;
		},
		callFunction(dateVal) {
			let _this = this;
			// _this.setLoading(true);
			_this.setloadingList(true);
			let dateList = {
				startdt: dateVal[0],
				enddt: dateVal[1],
				hospitalGuid: ''
			};

			_this.setPar(dateVal, 2);
			// axios.all([
			// 	 _this.GetRegionAVGScore(dateList),
			// 	 _this.GetHospAvgScore(dateList),
			// 	 _this.GetCount(dateList),
			// 	 _this.GetSummary(dateList),
			// 	 _this.GetQCedReportMonthly({modalityType:'',bodyPart:'',scanType:'',startdt:dateVal[0],enddt:dateVal[1]}),
			// 	 _this.GetUnqualifiedReportMonthly({hospitalGuid:dateList.hospitalGuid,modalityType:'',bodyPart:'',scanType:'',startdt:dateVal[0],enddt:dateVal[1]}),
			// 	 _this.GetDoctorsTop5AvgScore()
			// ]).then(axios.spread(function(){
			//    _this.setLoading(false);
			// }))
			// 监察员树层级
			_this.GetRegionAVGScore(dateList).then(res => {
				_this.mapLoading = false;
			});
			_this.GetHospAvgScore(dateList).then(res => {
				_this.lineLoading = false;
			});
			_this.GetCount(dateList).then(res => {
				_this.countLoading = false;
			});
			_this.GetSummary(dateList).then(res => {
				_this.pieLoading = false;
			});
			_this.GetQCedReportMonthly({ modalityType: '', bodyPart: '', scanType: '', startdt: dateVal[0], enddt: dateVal[1] }).then(res => {
				_this.portraitLoading = false;
			});
			_this.GetUnqualifiedReportMonthly({ hospitalGuid: dateList.hospitalGuid, modalityType: '', bodyPart: '', scanType: '', startdt: dateVal[0], enddt: dateVal[1] })
			.then(res => {
				_this.doublelineLoading = false;
			});
			_this.GetDoctorsTop5AvgScore().then(res => {
				_this.tableLoading = false;
			});
		},
		datePicker(val) {
			this.setDate(val);
			this.callFunction(val);
		},
		resetParameter() {
			this.parameter = {
				modalityType: '',
				bodyPart: '',
				scanType: '',
				startdt: '',
				enddt: ''
			};
		},
		judgeParameter(item) {
			let _this = this;
			switch (item.type) {
				case 'all':
					_this.resetParameter();
					break;
				case 'modalityType':
					_this.resetParameter();
					_this.parameter.modalityType = item.name;
					break;
				case 'scanType':
					_this.resetParameter();
					_this.parameter.scanType = item.name;
					break;
				case 'bodypart':
					_this.resetParameter();
					_this.parameter.bodyPart = item.name;
					break;
				default:
					_this.resetParameter();
					break;
			}
		},
		moveQCedReportMonthly(item) {
			this.judgeParameter(item);
			this.parameter.startdt = this.setDateArr.data[0];
			this.parameter.enddt = this.setDateArr.data[1];
			this.portraitLoading = true;
			this.GetQCedReportMonthly(this.parameter).then(res => {
				this.portraitLoading = false;
			});
		},
		moveunqualifiedMonthly(item) {
			this.judgeParameter(item);
			this.parameter.startdt = this.setDateArr.data[0];
			this.parameter.enddt = this.setDateArr.data[1];
			this.parameter.hospitalGuid = '';
			this.doublelineLoading = true;
			this.GetUnqualifiedReportMonthly(this.parameter).then(res => {
				this.doublelineLoading = false;
			});
		},
		doctorMore(type) {
			this.getAvgScoreParameter.pageIndex = 1;
			this.setTootipType(false);
			this.setvisBreadcrumbList();
			this.visbreadcrumbList.push(this.setDateArr.data[0] + '-' + this.setDateArr.data[1]);
			let name = type == 2 ? '全国医生排名' : '全国技师排名';
			this.visbreadcrumbList.push(name);
			this.visbreadcrumbList.push(type);
			this.$router.push('/home/visualization/vieMoreReports');
		}
	}
};
</script>

<style></style>
